const industrySubpageMobileStyles = `
@media (max-width: 960px) {
  .cms-page .hero-f {
    padding: 56px 20px 36px;
  }

  .cms-page .hero-f-inner,
  .cms-page .pblock-inner,
  .cms-page .story-card-box,
  .cms-page .cms-page__testimonial-grid {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 28px;
  }

  .cms-page .hero-f-left,
  .cms-page .pblock-inner > div:first-child,
  .cms-page .section-head,
  .cms-page .cms-page__section-head,
  .cms-page .story-card-left,
  .cms-page .story-card-right,
  .cms-page .final {
    text-align: center;
  }

  .cms-page .eyebrow,
  .cms-page .pblock-kicker,
  .cms-page .section-eyebrow,
  .cms-page .cms-page__eyebrow,
  .cms-page .story-card-eyebrow,
  .cms-page .kick,
  .cms-page .tag {
    display: inline-flex;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .hero-f h1,
  .cms-page .pblock h2,
  .cms-page .section-head h2,
  .cms-page .cms-page__section-title,
  .cms-page .story-card blockquote,
  .cms-page .final h2 {
    text-align: center;
  }

  .cms-page .hero-f .lede,
  .cms-page .pblock .lede,
  .cms-page .section-lede,
  .cms-page .cms-page__section-copy,
  .cms-page .final p {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  .cms-page .hero-f .cta-row,
  .cms-page .mc-section__actions {
    align-items: stretch !important;
    flex-direction: column !important;
    width: 100%;
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .hero-f .cta-row .btn,
  .cms-page .pblock .btn,
  .cms-page .final .btn,
  .cms-page .mc-section__actions .btn {
    justify-content: center;
    width: 100%;
  }

  .cms-page .trust-card {
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
  }

  .cms-page .trust-stats,
  .cms-page .trust-badges,
  .cms-page .impact-inner,
  .cms-page .story-card-stats,
  .cms-page .cms-page__testimonial-stats {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  .cms-page .trust-badges {
    align-items: stretch;
    flex-direction: column;
  }

  .cms-page .trust-stat,
  .cms-page .trust-badge,
  .cms-page .impact-stat,
  .cms-page .cms-page__testimonial-stat {
    justify-content: center;
    text-align: center;
  }

  .cms-page .hero-f-right,
  .cms-page .form-frame,
  .cms-page .pmock {
    width: 100%;
    max-width: 520px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  .cms-page .form-frame-chrome .u,
  .cms-page .pmock-head .u {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cms-page .pblock,
  .cms-page .cms-page__section-shell,
  .cms-page .faq,
  .cms-page .final,
  .cms-page .story-card {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .cms-page .pblock {
    padding-top: 52px !important;
    padding-bottom: 52px !important;
  }

  .cms-page .cms-page__section-shell,
  .cms-page .faq,
  .cms-page .story-card {
    padding-top: 56px !important;
    padding-bottom: 56px !important;
  }

  .cms-page .final {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }

  .cms-page .pblock-inner,
  .cms-page .story-card-inner,
  .cms-page .faq-inner,
  .cms-page .cms-page__section-inner {
    max-width: 720px;
  }

  .cms-page .pblock-inner > div,
  .cms-page .story-card-left,
  .cms-page .story-card-right,
  .cms-page .cms-page__testimonial-brand,
  .cms-page .cms-page__testimonial-main {
    min-width: 0;
  }

  .cms-page .bullets {
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
    text-align: left;
  }

  .cms-page .story-card-meta,
  .cms-page .story-card-cite,
  .cms-page .cms-page__testimonial-cite {
    justify-content: center;
  }

  .cms-page .faq-q {
    text-align: left;
  }

  .cms-page .donate-amounts,
  .cms-page .pkg-grid,
  .cms-page .ret-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 560px) {
  .cms-page .hero-f h1 {
    font-size: 34px;
  }

  .cms-page .donate-amounts,
  .cms-page .pkg-grid,
  .cms-page .ret-grid,
  .cms-page .trust-stats,
  .cms-page .story-card-stats,
  .cms-page .cms-page__testimonial-stats {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}
`

export default industrySubpageMobileStyles
